import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInputComponent } from './custom-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [CustomInputComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  exports: [CustomInputComponent],
})
export class CustomInputModule {}
